module.exports = __webpack_public_path__ + "static/media/Widget-Setup-Image.08cdfe04.png";